import _extends from "@babel/runtime/helpers/extends";
import cn from 'classnames';
export const pickStyle = (props, key, params) => {
  var _props$classNames, _props$styles;
  return {
    className: cn(params == null ? void 0 : params.className, (_props$classNames = props.classNames) == null ? void 0 : _props$classNames[key]),
    style: _extends({}, params == null ? void 0 : params.style, (_props$styles = props.styles) == null ? void 0 : _props$styles[key]),
    'data-style-layer': key
  };
};